import { NURSE_PATH } from '@constants/routes';
import { useAppSelector } from '@store/hooks';
import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { FaArrowLeftLong } from 'react-icons/fa6';
import { useTranslation } from 'react-i18next';
import Table from 'react-bootstrap/Table';
import CloseIcon from '@components/SvgComponents/CloseIcon';
import { FaRegTrashCan } from 'react-icons/fa6';
import EditIconWhite from '@components/SvgComponents/EditIconWhite';
import { TbDeviceIpadX } from 'react-icons/tb';
import {
    addNotes,
    getUserAttributes,
    scan,
    addDeletionReason,
    handleDeleteUser,
} from '@utils/authUtils';
import { useNavigate } from 'react-router-dom';
import ModalPopUp from '@components/ModalPopUpComponent';
import TextAreaPopUp from '@components/TextAreaPopUpComponent';
import {
    getUserData,
    getUserInfo,
    getUserName,
    updateUser,
} from '@utils/utils';
import { USER_ROLE, TENANT_ID } from '@constants/cognitoAttributes';
import UserDeviceList from './UserDeviceList';
import {
    APPROVED,
    BLOCKED,
    NURSE,
    REJECTED,
    VERIFIED,
    WAITING,
    WAITING_FOR_APPROVAL,
} from '@constants/constants';
import {
    capitalizeFirstLetter,
    formatDateDMY,
    generateUniqueTimestamp,
    getDataUsingUserId,
    getDataUuid,
    sendStatusNotification,
} from '@utils/sharedUtils';
import DataLoader from '@components/DataLoader';
import Swal from 'sweetalert2';
import { sendPushNotification } from '@utils/notificationUtils';
import { useAuditLog } from '../../contexts/AuditLogContext';

const MySwal = Swal;

type DeviceDetails = {
    name: string;
    device_id: string;
    date: string;
    id: string;
};

const NurseManagementDetailPage = () => {
    const nurseDetail = useAppSelector((state) => state.user.NurseDetails);
    const { t } = useTranslation();
    const [created_by, setCreatedBy] = useState('');
    const [loading, setLoading] = useState(true);
    const [showApproveModal, setShowApproveModal] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showUnBlockModal, setShowUnBlockModal] = useState(false);
    const [showTextModal, setShowTextModal] = useState(false);
    const [showBlockModal, setShowBlockModal] = useState(false);
    // let accountStatus = 'waiting For Approval';
    const [userStatus, setUserStatus] = useState<string>(
        nurseDetail?.status ? nurseDetail?.status : ''
    );
    const loggedInUserId = useAppSelector(
        (state) => state.login.loggedInUserID
    );
    const handleDeleteClick = () => {
        setShowDeleteModal(true);
    };
    const navigate = useNavigate();
    const { addLog } = useAuditLog();
    const [deviceDetails, setDeviceDetails] = useState<DeviceDetails[]>([]);
    const loggedInUserEmail = useAppSelector(
        (state) => state.login.loggedInUserEmail
    );

    useEffect(() => {
        if (!nurseDetail) {
            // const pathname = location.pathname;
            // // Check if the pathname matches any of the paths from AppConfig
            // if (pathname.startsWith(HOSPITAL_USER_PATH + '/')) {
            //     navigate(HOSPITAL_USER_PATH);
            // } else if (pathname.startsWith(INDIVIDUAL_USER_PATH + '/')) {
            //     navigate(INDIVIDUAL_USER_PATH);
            // }
            navigate(NURSE_PATH);
        }
        handleNameAndStatus(nurseDetail?.createdBy ?? '');
        fetchDeviceDetails();
    }, [nurseDetail, navigate]);

    const fetchDeviceDetails = async () => {
        try {
            if (nurseDetail) {
                const nurse = await getDataUsingUserId(
                    'nurse_device',
                    nurseDetail?.id
                );
                let assigned = [];
                if (nurse && nurse.Items && nurse.Items.length > 0) {
                    for (const device of nurse.Items) {
                        const deviceData = await getDataUuid(
                            'devices',
                            device?.device_id?.S ? device?.device_id?.S : ''
                        );
                        if (deviceData) {
                            const assignedDevice = deviceData;
                            const data = {
                                name: assignedDevice?.device_name?.S
                                    ? capitalizeFirstLetter(
                                          assignedDevice?.device_name?.S
                                      )
                                    : '',
                                device_id: assignedDevice?.device_id?.S
                                    ? capitalizeFirstLetter(
                                          assignedDevice?.device_id?.S
                                      )
                                    : '',
                                date: assignedDevice?.created_at?.S
                                    ? formatDateDMY(
                                          assignedDevice?.created_at?.S
                                      )
                                    : '',
                                id: assignedDevice?.uuid?.S
                                    ? assignedDevice?.uuid?.S
                                    : '',
                            };
                            assigned.push(data);
                        }
                    }
                    setDeviceDetails(assigned);
                }
            }
        } catch (error: any) {
            let errorMessage;
            switch (error.name) {
                case 'ResourceNotFoundException':
                    errorMessage = 'Error: The specified table does not exist.';
                    break;
                case 'ProvisionedThroughputExceededException':
                    errorMessage =
                        'Error: The request rate is too high. Please try again later.';
                    break;
                case 'ValidationException':
                    errorMessage =
                        'Error: The provided key element does not match the schema.';
                    break;
                case 'DynamoDBServiceException':
                    errorMessage = `Service Error: ${error.message}`;
                    break;
                default:
                    (errorMessage = 'An unknown error occurred:'), error;
                    break;
            }
            MySwal.fire({
                position: 'top-end', // Position the toast in the top-right corner
                icon: 'error',
                title: errorMessage,
                showConfirmButton: false,
                timer: 3000,
                toast: true,
                customClass: {
                    popup: '!text-red !bg-light_red', // Add custom class to the popup
                },
                width: 'auto',
            });
            // setError(error.message);
            // console.log('error:', error.message);
        } finally {
            setLoading(false);
        }
    };
    // handleNameAndStatus(nurseDetail?.createdBy)
    // const nurseData = {
    //     name: 'Central Hospital',
    //     deviceId: 'CH12345',
    //     hospitalId: 'HID98765',
    //     hospitalName: 'Central Hospital',
    //     createdDate: '2024-06-01',
    //     address: '123 Main St, Anytown, USA',
    //     createdBy: 'Dr. John Doe',
    //     accountStatus: 'Active',
    //     approvedBy: 'Dr. Jane Smith',
    // };
    // const deviceAssignments = [
    //     { deviceName: 'DO4125', assignedDate: '2024-06-15' },
    //     { deviceName: 'DO4136', assignedDate: '2024-06-16' },
    //     // Add more data as needed
    // ];

    // const handleDelete = () => {
    //     // Add your logic to handle delete with reason here
    //     setShowDeleteModal(false);
    //     setShowTextModal(false);
    // };

    const handleDelete = async (reason: string) => {
        // adminDeleteUser(user.email);
        const attributes = await getUserAttributes();

        if (typeof attributes !== 'string' && attributes !== null) {
            const updatedBy = attributes['custom:tenant_id'] ?? '';

            if (nurseDetail) {
                // console.log('data', userData);
                await addDeletionReason(
                    updatedBy,
                    reason,
                    nurseDetail.tenantUUid
                );
                await handleDeleteUser(
                    nurseDetail.tenantUUid,
                    nurseDetail.id,
                    NURSE
                ).then(() => {
                    window.location.reload();
                });
                setShowDeleteModal(false);
                setShowTextModal(false);
            }
        }
    };

    const handleNameAndStatus = async (tenantUuid: string) => {
        if (tenantUuid == '') {
            return '--';
        }
        try {
            const res = await scan('user_info', tenantUuid);
            if (res) {
                const details = res[0];
            }

            setCreatedBy('Surya');
        } catch (error) {
            console.error('Error fetching info:', error);
            return null; // Skip this user in case of error
        }
    };

    const now = new Date();
    // const formattedDateTime = now.toLocaleString();
    const formattedDateTime = generateUniqueTimestamp();

    const updateStatus = async (status: string) => {
        try {
            const attributes = await getUserAttributes();

            if (typeof attributes === 'string' || attributes === null) {
                return;
            }

            const tenantUuid = attributes[TENANT_ID] ?? '';
            const attributeNames = {
                '#status': 'status',
                '#modified_by': 'modified_by',
                '#modified_at': 'modified_at',
                '#approved_by': 'approved_by',
            };

            const attributeValues = {
                ':status': { S: status },
                ':modified_by': { S: tenantUuid },
                ':modified_at': { S: formattedDateTime },
                ':approved_by': { S: loggedInUserId },
            };

            const updateExpression =
                'SET #status = :status, #modified_by = :modified_by, #modified_at = :modified_at, #approved_by = :approved_by';

            if (!nurseDetail?.tenantUUid) {
                return;
            }

            // const info = await getUserInfo('user_info', nurseDetail.tenantUUid);
            const info = await getDataUsingUserId('user_info', nurseDetail.id);
            if (!info || !info.Items) {
                return;
            }
            const uuid = info?.Items[0]?.uuid?.S;

            if (uuid) {
                await updateUser(
                    'user_info',
                    uuid,
                    attributeNames,
                    attributeValues,
                    updateExpression
                );
                setUserStatus(status);

                addLog(
                    'Nurse Status Updated',
                    uuid,
                    'User Info',
                    loggedInUserId,
                    { 'Status': status, 'Nurse': info?.Items[0]?.email?.S },
                    window.location.hostname
                );
            }

            const email = info?.Items?.[0]?.email?.S;
            const toAddress = email ? email : '';

            if (status.toLowerCase() == BLOCKED.toLowerCase()) {
                // await sendPushNotification({user_id: nurseDetail.id ? nurseDetail.id : '', type: 'blocked', device_id: '', reason: '', assigned_by: loggedInUserId });
                const notificationData = {
                    users: toAddress,
                    status: 'blocked',
                };

                // Send the data to the sharedUtils.ts function
                await sendStatusNotification(notificationData);
            } else if (status.toLowerCase() == APPROVED.toLowerCase()) {
                // await sendPushNotification({user_id: nurseDetail.id ? nurseDetail.id : '', type: 'approved', device_id: '', reason: '', assigned_by: loggedInUserId });
                const notificationData = {
                    users: toAddress,
                    status: 'approved',
                };

                // Send the data to the sharedUtils.ts function
                await sendStatusNotification(notificationData);
            } else if (status.toLowerCase() == REJECTED.toLowerCase()) {
                // await sendPushNotification({user_id: nurseDetail.id ? nurseDetail.id : '', type: 'rejected', device_id: '', reason: '', assigned_by: loggedInUserId });
                const notificationData = {
                    users: toAddress,
                    status: 'rejected',
                };

                // Send the data to the sharedUtils.ts function
                await sendStatusNotification(notificationData);
            }
        } catch (error) {
            console.error('Error updating status:', error);
        }
    };

    const getStatusClass = (status: any) => {
        switch (status.toLowerCase()) {
            case 'waiting':
                return 'bg-warning'; // Tailwind CSS class for yellow background
            case 'approved':
                return 'bg-success'; // Tailwind CSS class for green background
            case 'rejected':
                return 'bg-danger'; // Tailwind CSS class for red background
            default:
                return 'bg-gray-500'; // Default background color
        }
    };

    return (
        <>
            <div className="mt-5">
                <div className="flex justify-content-between align-items-center">
                    <div className="flex font-bold text-black test-base">
                        <Link to={NURSE_PATH}>
                            <div className="flex items-center cursor-pointer">
                                <FaArrowLeftLong className="cursor-pointer" />{' '}
                                <div className="font-semibold ml-2">
                                    {t('nurse_details.title')}
                                </div>
                            </div>
                        </Link>
                    </div>

                    {/* <div className="flex cursor-pointer"> */}
                    {(userStatus.toLowerCase() == WAITING.toLowerCase() ||
                        userStatus.toLowerCase() ==
                            WAITING_FOR_APPROVAL.toLowerCase()) && (
                        <div className="flex cursor-pointer w-[20%] ">
                            <button
                                className="!bg-primary py-1 px-3 text-white mr-3"
                                onClick={() => setShowApproveModal(true)}
                            >
                                {t('nurse_details.approve')}
                            </button>
                            <button
                                className="text-primary !bg-white py-1 px-3 border border-primary"
                                onClick={() => setShowModal(true)}
                            >
                                {t('nurse_details.reject')}
                            </button>
                        </div>
                    )}
                    {userStatus.toLowerCase() == APPROVED.toLowerCase() && (
                        <div className="cursor-pointer flex w-[13%]">
                            <button
                                className="text-white bg-secondary inline-block py-1 px-3 border"
                                onClick={() => setShowBlockModal(true)}
                            >
                                {t('nurse_details.block')}
                            </button>
                            {/* <button
                                    className="text-danger px-3 py-1 rounded flex items-center "
                                    onClick={handleDeleteClick}
                                >
                                    <span className="text-red mr-2">
                                        <FaRegTrashCan className="text-red" />
                                    </span>
                                    {t('nurse_details.delete')}
                                </button> */}
                        </div>
                    )}
                    {userStatus.toLowerCase() == REJECTED.toLowerCase() && (
                        <div className="flex cursor-pointer w-[14%]">
                            <button
                                className="!bg-primary py-1 px-3 text-white mr-3"
                                onClick={() => setShowApproveModal(true)}
                            >
                                {t('nurse_details.approve')}
                            </button>
                            {/* <button
                                       className="text-danger px-3 py-1 rounded flex items-center "
                                       onClick={handleDeleteClick}
                                   >
                                       <span className="text-red mr-2">
                                           <FaRegTrashCan className="text-red" />
                                       </span>
                                       {t('nurse_details.delete')}
                                   </button> */}
                        </div>
                    )}
                    {userStatus.toLowerCase() == BLOCKED.toLowerCase() && (
                        <div className="flex cursor-pointer w-[14%]">
                            <button
                                className="text-primary py-1 px-3 border border-primary"
                                onClick={() => setShowUnBlockModal(true)}
                            >
                                {t('nurse_details.unblock')}
                            </button>
                        </div>
                    )}
                    {/* </div> */}
                </div>
                <div className="cart rounded-2xl bg-white flex flex-col justify-content-center rounded-2xl mt-5 px-3 ml-5 w-11/12 mx-auto">
                    <div className="flex flex-wrap mb-4 pt-4">
                        <div className="flex w-1/2 pl-8 ">
                            <div className="w-1/3 flex flex-col">
                                <div className="py-2 flex items-center">
                                    <label className="font-bold text-black">
                                        {t('nurse_details.name')}
                                    </label>
                                </div>
                                <div className="py-2 flex items-center">
                                    <label className="font-bold text-black">
                                        {t('nurse_details.hospital_id')}
                                    </label>
                                </div>
                                <div className="py-2 flex items-center">
                                    <label className="font-bold text-black">
                                        {t('nurse_details.created_date')}
                                    </label>
                                </div>
                                <div className="py-2 flex items-center">
                                    <label className="font-bold text-black">
                                        {t('nurse_details.created_by')}
                                    </label>
                                </div>
                                <div className="py-2 flex items-center">
                                    <label className="font-bold text-black">
                                        {t('nurse_details.account_status')}
                                    </label>
                                </div>
                                <div className="pt-3 pb-2 flex items-center">
                                    <label className="font-bold text-black">
                                        {t('nurse_details.approved_by')}
                                    </label>
                                </div>
                            </div>
                            <div className="w-2/3 flex flex-col">
                                <div className="py-2 flex items-center">
                                    <span className="ml-3">
                                        {nurseDetail?.name
                                            ? capitalizeFirstLetter(
                                                  nurseDetail?.name
                                              )
                                            : '--'}
                                    </span>
                                </div>
                                <div className="py-2 flex items-center">
                                    <span className="ml-3">
                                        {nurseDetail?.hospitalId
                                            ? nurseDetail?.hospitalId.toUpperCase()
                                            : '--'}
                                    </span>
                                </div>
                                <div className="py-2 flex items-center">
                                    <span className="ml-3">
                                        {nurseDetail?.createdAt
                                            ? nurseDetail?.createdAt
                                            : '--'}
                                    </span>
                                </div>
                                <div className="py-2 flex items-center">
                                    <span className="ml-3">
                                        {nurseDetail?.createdBy
                                            ? capitalizeFirstLetter(
                                                  nurseDetail?.createdBy
                                              )
                                            : '--'}
                                    </span>
                                </div>
                                <div className="py-2 flex items-center">
                                    <div
                                        className={`2xl:mr-11 ${getStatusClass(userStatus)} text-white inline-block rounded-full px-2 py-1`}
                                    >
                                        {userStatus.toLowerCase() ===
                                        WAITING.toLowerCase()
                                            ? WAITING_FOR_APPROVAL
                                            : userStatus}
                                    </div>
                                </div>
                                <div className="py-2 flex items-center">
                                    <span className="ml-3">
                                        {nurseDetail?.approvedBy
                                            ? capitalizeFirstLetter(
                                                  nurseDetail?.approvedBy
                                              )
                                            : '--'}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="flex w-1/2 pr-12">
                            <div className="w-1/3 flex flex-col">
                                <div className="py-2 flex items-center">
                                    <label className="font-bold text-black">
                                        {t('nurse_details.nurse_email')}
                                    </label>
                                </div>
                                <div className="py-2 flex items-center">
                                    <label className="font-bold text-black">
                                        {t('nurse_details.nurse_id')}
                                    </label>
                                </div>
                                <div className="py-2 flex items-center">
                                    <label className="font-bold text-black">
                                        {t('nurse_details.hospital_name')}
                                    </label>
                                </div>
                                <div className="py-2 flex items-center">
                                    <label className="font-bold text-black text-wrap">
                                        {t('nurse_details.address')}
                                    </label>
                                </div>
                            </div>
                            <div className="w-2/3 flex flex-col">
                                <div className="py-2 flex items-center">
                                    <span className="ml-3">
                                        {nurseDetail?.email_id
                                            ? nurseDetail?.email_id
                                            : '--'}
                                    </span>
                                </div>
                                <div className="py-2 flex items-center">
                                    <span className="ml-3">
                                        {nurseDetail?.nurseId
                                            ? nurseDetail?.nurseId.toUpperCase()
                                            : '--'}
                                    </span>
                                </div>
                                <div className="py-2 flex items-center">
                                    <span className="ml-3">
                                        {nurseDetail?.hospitalName
                                            ? capitalizeFirstLetter(
                                                  nurseDetail?.hospitalName
                                              )
                                            : '--'}
                                    </span>
                                </div>
                                <div className="py-2 flex items-center">
                                    <span className="ml-3 text-wrap">
                                        {nurseDetail?.address
                                            ? nurseDetail?.address
                                            : '--'}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mt-5">
                    <div className="font-bold text-primary">
                        <div className="flex items-center">
                            <div className="ml-4">
                                {t('nurse_details.assigned_devices')}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="bg-white flex flex-col rounded-2xl mt-4 ml-4 w-[28rem] h-[29rem] relative">
                    <UserDeviceList deviceList={deviceDetails} />
                    {/* <Table className="rounded-2xl">
                    <thead>
                        <tr
                            className="border-none bg-white"
                            style={{ background: '#F9F9F9' }}
                        >
                            <th className="border-none font-bold text-black !normal-case">
                            {t('nurse_details.device_id')}
                            </th>
                            <th className="border-none font-bold text-black !normal-case">
                            {t('nurse_details.assigned_date')}
                            </th>
                        </tr>
                    </thead>
                    <tbody> */}
                    {/* {deviceAssignments.length > 0 ? (
                            deviceAssignments.map((assignment, index) => (
                                <>
                                    <tr key={index} className="border">
                                        <td className="border-none">
                                            {assignment.deviceName}
                                        </td>
                                        <td className="border-none">
                                            {assignment.assignedDate}
                                        </td>
                                    </tr>
                                </>
                            ))
                        ) : ( */}
                    {/* <>
                            <tr className="border-none">
                                <td
                                    className="border-none text-center py-5"
                                    colSpan={2}
                                >
                                    <div className="flex justify-center">
                                        <TbDeviceIpadX
                                            size={40}
                                            className="text-primary"
                                        />
                                    </div>
                                    {t('nurse_details.no_data')}
                                </td>
                            </tr>
                        </> */}
                    {/* )} */}
                    {/* </tbody>
                </Table> */}
                </div>
            </div>
            <ModalPopUp
                show={showDeleteModal}
                message={t('pop_up.nurse_delete_msg')}
                onConfirm={() => {
                    setShowTextModal(true);
                    setShowDeleteModal(false);
                }}
                onCancel={() => setShowDeleteModal(false)}
            />
            <TextAreaPopUp
                show={showTextModal}
                message={t('pop_up.delete_reason_msg')}
                onConfirm={handleDelete}
                onCancel={() => {
                    setShowTextModal(false);
                    setShowDeleteModal(false);
                }}
            />
            <ModalPopUp
                show={showApproveModal}
                message={t('pop_up.nurse_approve')}
                onConfirm={() => {
                    updateStatus(APPROVED);
                    setShowApproveModal(false);
                }}
                onCancel={() => setShowApproveModal(false)}
            />
            <ModalPopUp
                show={showModal}
                message={t('pop_up.nurse_reject')}
                onConfirm={() => {
                    updateStatus(REJECTED);
                    setShowModal(false);
                }}
                onCancel={() => setShowModal(false)}
            />
            <ModalPopUp
                show={showBlockModal}
                message={t('pop_up.nurse_block')}
                onConfirm={() => {
                    updateStatus(BLOCKED);
                    setShowBlockModal(false);
                }}
                onCancel={() => setShowBlockModal(false)}
            />
            <ModalPopUp
                show={showUnBlockModal}
                message={t('pop_up.nurse_unblock')}
                onConfirm={() => {
                    updateStatus(APPROVED);
                    setShowUnBlockModal(false);
                }}
                onCancel={() => setShowUnBlockModal(false)}
            />
            {loading && <DataLoader />}
        </>
    );
};
export default NurseManagementDetailPage;
